export default __webpack_public_path__ + "c9d31851febf843a5909097613963d28.png";